import { PureComponent } from "react";

import { MoreHoriz } from "@livechat/design-system-icons";
import { ActionMenu, ActionMenuItem, Button, IActionMenuOption, Icon } from "@livechat/design-system-react-components";

import { EventPlace, trackEngagement } from "helpers/analytics";
import {
  ITicket,
  TicketActionTypes,
  TicketSilo,
  TicketSiloFormattedValues,
  TicketSiloToActionType,
} from "interfaces/entities/ticket";

interface IProps {
  ticket: ITicket;
  isOwner: boolean;
  canManageTickets: boolean;
  canDeleteTicket: boolean;
  isMemberOfTicketTeam: boolean;
  onSiloChange(silo: TicketSilo, ticketId: string): void;
  onDeleteTicket(): void;
}

interface IState {
  isVisible: boolean;
  disabled: boolean;
}

class TicketDetailsMoreDropdown extends PureComponent<IProps, IState> {
  state = {
    disabled: !this.props.canManageTickets || !this.props.isMemberOfTicketTeam,
    isVisible: false,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleDeleteTicket = () => {
    this.props.onDeleteTicket();
    this.handleClose();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleSiloChange = (silo: TicketSilo) => {
    this.props.onSiloChange(silo, this.props.ticket.id);
    this.handleClose();
    trackEngagement("Tickets: Change silo actions", EventPlace.TicketDetails, {
      from: this.props.ticket.silo,
      to: silo,
      place: EventPlace.TicketDetails,
    });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private getItemKey = (ticketActionType: TicketActionTypes) => {
    return `ticket-details-more-options-${ticketActionType}`;
  };

  private defaultItems: IActionMenuOption[] = [
    ...[TicketSilo.Archive, TicketSilo.Spam, TicketSilo.Trash].map(silo => ({
      key: this.getItemKey(TicketSiloToActionType[silo]),
      element: (
        <ActionMenuItem kind={silo === TicketSilo.Trash ? "warning" : undefined}>
          Move to {TicketSiloFormattedValues[silo]}
        </ActionMenuItem>
      ),
      disabled: this.state.disabled,
      onClick: () => this.handleSiloChange(silo),
    })),
  ];

  private archiveItems = [
    {
      key: this.getItemKey(TicketActionTypes.Unarchive),
      element: <ActionMenuItem data-testid="test">Unarchive</ActionMenuItem>,
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onClick: () => this.handleSiloChange(TicketSilo.Tickets),
      disabled: this.state.disabled,
    },
    {
      key: this.getItemKey(TicketActionTypes.MoveToTrash),
      element: <ActionMenuItem kind="warning">Move to Trash</ActionMenuItem>,
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onClick: () => this.handleSiloChange(TicketSilo.Trash),
      disabled: this.state.disabled,
    },
  ];

  private spamItems = [
    {
      key: this.getItemKey(TicketActionTypes.NotSpam),
      element: <ActionMenuItem>Not spam</ActionMenuItem>,
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onClick: () => this.handleSiloChange(TicketSilo.Tickets),
      disabled: this.state.disabled,
    },
    {
      key: this.getItemKey(TicketActionTypes.DeleteForever),
      element: <ActionMenuItem kind="warning">Delete forever</ActionMenuItem>,
      onClick: this.handleDeleteTicket,
      disabled: this.state.disabled,
    },
  ];

  private trashItems = [
    {
      key: this.getItemKey(TicketActionTypes.Restore),
      element: <ActionMenuItem>Restore</ActionMenuItem>,
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onClick: () => this.handleSiloChange(TicketSilo.Tickets),
      disabled: this.state.disabled,
    },
    {
      key: this.getItemKey(TicketActionTypes.DeleteForever),
      element: <ActionMenuItem kind="warning">Delete forever</ActionMenuItem>,
      onClick: this.handleDeleteTicket,
      disabled: this.state.disabled,
    },
  ];

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleClose = () => {
    this.setState({ isVisible: false });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private handleTriggerClick = () => {
    this.setState(prevState => ({ isVisible: !prevState.isVisible }));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private getItemsByTicketSilo = () => {
    const {
      isOwner,
      canDeleteTicket,
      ticket: { silo },
    } = this.props;
    if (silo === TicketSilo.Archive) {
      return this.archiveItems;
    }
    if (silo === TicketSilo.Spam) {
      return isOwner && canDeleteTicket ? this.spamItems : this.spamItems.slice(0, -1);
    }
    if (silo === TicketSilo.Trash) {
      return isOwner && canDeleteTicket ? this.trashItems : this.trashItems.slice(0, -1);
    }
    return this.defaultItems;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return (
      <ActionMenu
        options={this.getItemsByTicketSilo()}
        visible={this.state.isVisible}
        placement="bottom-end"
        onClose={this.handleClose}
        triggerRenderer={
          <Button
            data-testid="ticket-info"
            kind="plain"
            size="compact"
            onClick={this.handleTriggerClick}
            icon={<Icon source={MoreHoriz} />}
          />
        }
      />
    );
  }
}

export default TicketDetailsMoreDropdown;
